import {
	getInvolvedHeroImage,
	getInvolvedHeroMobileImage,
	vlunteerImage,
	partnerImage,
	communityImage,
} from "../images";

export const heroData = [
	{
		imageSource: [getInvolvedHeroImage, getInvolvedHeroMobileImage],
		heading: "Get Involved",
	},
];

export const getInvolvedSectionData = [
	{
		imageSource: vlunteerImage,
		heading: "Become a Volunteer",
		description: [
			"Our volunteers are an integral part of the success of our programs. A huge proportion of our volunteer activities are currently organised as virtual programs and flexible with your availability and schedule. Your volunteer activities include event planning, program administration, career educators, community educators, etc.",
			"Are you interested in learning more about mentoring, community development and youth empowerment? Do you want to develop your intellectual, emotional, social and moral well-being? Do you want to put a smile on the faces of your community and those in developing nations? We would love to hear from you!",
		],
		link: "https://bit.ly/3Hvolunteer",
		linkText: "Volunteer with us",
		id: "volunteer",
		imageClass: "getInvolvedVolunteer",
	},
	{
		imageSource: partnerImage,
		heading: "Become a partner",
		description: [
			"We are open to partnership with individuals or organizations interested in a collaborative effort to implement any of our programs. Partners must meet qualifying conditions for a charitable activity.",
			"Are you an individual or organization interested in a joint effort to deliver any of our programs? “Looking to partner with us? We would love to hear about your ideas!",
		],
		link: "https://bit.ly/3HPartners",
		linkText: "Partner with us",
		id: "partner",
	},
	{
		imageSource: communityImage,
		heading: "Register your Community",
		description: [
			"We support community-based learning and development? You can register your community/organization/association for a tailored learning session for your members. We would love to support your community!",
		],
		link: "https://bit.ly/3HPartners",
		linkText: "Register now",
		id: "community",
	},
];
